import React, { useState } from 'react';
import { Tag } from 'lucide-react';
import type { BulkUpdates } from '../../../types/bulk';
import { BulkApplyButton, BulkFieldRow, bulkSelectClass } from '../BulkFieldRow';

interface BulkListingTypeFieldProps {
  onUpdate: (updates: BulkUpdates) => void;
}

export function BulkListingTypeField({ onUpdate }: BulkListingTypeFieldProps) {
  const [listingType, setListingType] = useState<'auction' | 'fixed' | ''>('');

  const handleApply = () => {
    if (listingType) {
      onUpdate({ listingType });
      setListingType('');
    }
  };

  return (
    <BulkFieldRow
      icon={<Tag className="w-5 h-5 text-gray-500 shrink-0" />}
      label="出品形式を変更"
    >
      <select
        value={listingType}
        onChange={(e) => setListingType(e.target.value as 'auction' | 'fixed')}
        className={bulkSelectClass}
      >
        <option value="">選択してください</option>
        <option value="auction">オークション</option>
        <option value="fixed">定額</option>
      </select>
      <BulkApplyButton disabled={!listingType} onClick={handleApply} />
    </BulkFieldRow>
  );
}
